import { render, staticRenderFns } from "./ContentInput.vue?vue&type=template&id=53d0b5a6&"
import script from "./ContentInput.vue?vue&type=script&lang=js&"
export * from "./ContentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports